/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vast_Swift_Crow_WadeInputs */

const en_vast_swift_crow_wade = /** @type {(inputs: Vast_Swift_Crow_WadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Login`)
};

const de_vast_swift_crow_wade = /** @type {(inputs: Vast_Swift_Crow_WadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Login`)
};

/**
* | output |
* | --- |
* | "Login" |
*
* @param {Vast_Swift_Crow_WadeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const vast_swift_crow_wade = /** @type {((inputs?: Vast_Swift_Crow_WadeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vast_Swift_Crow_WadeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vast_swift_crow_wade(inputs)
	return de_vast_swift_crow_wade(inputs)
});